import { Channel } from '@at/consumer-web-types'

export const getIsNewVehicleSearch = (search: string, channel: Channel): boolean => {
    const isNewSearch = search.includes('year-from=new')
    const isCarOrVans = channel === Channel.cars || channel === Channel.vans

    return isNewSearch && isCarOrVans
}
